/* eslint no-param-reassign: 0 */
import {forEach, mapKeys, orderBy} from 'lodash';
import commonMutations from 'top20common/distribution/store/mutations';

import {
  CHANGE_COMPANIES_OF_INTEREST_REQUEST,
  CHANGE_COMPANIES_OF_INTEREST_SUCCESS,
  CHANGE_NEW_PASSWORD_FIELD,
  CHANGE_PASSWORD_FAIL,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_SAVED_SEARCH,
  CHANGE_VALUE_FIELD,
  DELETE_SAVED_SEARCH,
  GET_SAVED_SEARCHES_LIST,
  LOGIN_ERROR,
  LOGIN_REQUEST,
  RESET_ALL_FIELDS,
  RESET_PASSWORD_REQUEST,
  SHIFT_PASSWORD_COMPONENT
} from './constants';

export default {
  ...commonMutations,
  [CHANGE_COMPANIES_OF_INTEREST_REQUEST](state) {
    state.companiesOfInterestFormState = {
      ...state.companiesOfInterestFormState,
      loading: true
    };
  },
  [CHANGE_COMPANIES_OF_INTEREST_SUCCESS](state, payload) {
    state.companiesOfInterestFormState = {
      ...state.companiesOfInterestFormState,
      meta: payload.meta,
      loading: false,
      companiesList: payload.result.companies_of_interest
    };
  },
  [LOGIN_REQUEST](state) {
    state.userState = {
      ...state.userState,
      loading: true
    };
  },
  loginSuccess(state, payload) {
    // toDo: change
    state.userState = {
      ...state.userState,
      loading: false,
      details: payload
    };
  },
  [LOGIN_ERROR](state, error) {
    state.userState = {
      ...state.userState,
      loading: false,
      error
    };
  },
  [RESET_ALL_FIELDS](state, formType) {
    const localState = {...state};
    forEach(localState[`${formType}Form`], (field, key) => {
      if (typeof field === 'boolean') {
        localState[`${formType}Form`][key] = false;
      } else {
        localState[`${formType}Form`][key] = null;
      }
    });
    state[`${formType}Form`] = localState[`${formType}Form`];
  },
  [SHIFT_PASSWORD_COMPONENT](state, value) {
    state.resetPasswordForm = {
      ...state.resetPasswordForm,
      emailInputComponent: value,
      loading: false
    };
  },
  [CHANGE_NEW_PASSWORD_FIELD](state, payload) {
    state.changePasswordForm = {
      password: payload
    };
  },
  [CHANGE_PASSWORD_REQUEST](state, payload) {
    state.changedPasswordConfirmation = {
      ...state.changedPasswordConfirmation,
      loading: payload
    };
  },
  [CHANGE_PASSWORD_SUCCESS](state, payload) {
    const {detail} = payload;
    state.changedPasswordConfirmation = {
      ...state.changedPasswordConfirmation,
      loading: null,
      error: null,
      detail,
      success: true
    };
  },
  [CHANGE_PASSWORD_FAIL](state, error) {
    state.changedPasswordConfirmation = {
      ...state.changedPasswordConfirmation,
      loading: false,
      error
    };
  },
  [RESET_PASSWORD_REQUEST](state) {
    state.resetPasswordForm.loading = true;
  },
  clearErrors(state) {
    state.userState.error = null;
  },
  emailConfirmationError(state, errors) {
    state.emailConfirmation = {
      ...state.emailConfirmation,
      errors
    };
  },
  emailConfirmationSuccess(state) {
    state.emailConfirmation = {
      ...state.emailConfirmation,
      success: true
    };
  },
  passwordResetError(state, errors) {
    state.resetConfirmation = {
      ...state.resetConfirmation,
      errors
    };
  },
  passwordResetSuccess(state) {
    state.resetConfirmation = {
      ...state.resetConfirmation,
      success: true
    };
  },
  newPasswordChange(state, password) {
    state.resetConfirmation = {
      ...state.resetConfirmation,
      password
    };
  },
  resetPasswordFormUpdate(state, data) {
    state.resetPasswordForm = {
      ...state.resetPasswordForm,
      emailInputComponent: data.value,
      errors: data.errors,
      loading: false
    };
  },
  [GET_SAVED_SEARCHES_LIST](state, payload) {
    state.savedSearchesState.searches = payload;
  },
  [DELETE_SAVED_SEARCH](state, id) {
    state.savedSearchesState.searches = state.savedSearchesState.searches.filter(search => {
      return search.id !== id;
    });
  },
  [CHANGE_VALUE_FIELD](state, payload) {
    const {fieldOption: {fieldName}, fieldOption: {fieldValue}, formName} = payload;
    state[formName] = {
      ...state[formName],
      [fieldName]: fieldValue
    };
  },
  [CHANGE_SAVED_SEARCH](state, data) {
    const loading = data.loading;
    state.savedSearchesState = {
      ...state.savedSearchesState,
      loading
    };
  },
  changeCoiFormStateCompaniesList(state, data) {
    state.companiesOfInterestFormState.companiesList = data;
  },
  mutateFiltersState(state, data) {
    state.filtersState = {...state.filtersState, ...data};
  },
  initialFiltersMutation(state, filters) {
    const filtersObject = {};
    forEach(filters, (filterValues, type) => {
      filtersObject[type] = mapKeys(filterValues, 'value'); // ignoring the children for now.
    });
    state.filtersState = {
      loading: false,
      error: null,
      all: filtersObject
    };
  },
  markTop5GroupMutation(state, filterType) {
    state.filtersState.all[filterType] = mapKeys(orderBy(state.filtersState.all[filterType], 'count', 'desc'), 'value');
    Object.keys(state.filtersState.all[filterType]).forEach(function(element, index) {
      if (index < 5) {
        state.filtersState.all[filterType][element].type = 'countOrderGroup';
      } else {
        state.filtersState.all[filterType][element].type = 'alphabeticalOrderGroup';
      }
    });
  },
  mutateCompaniesOfInterestErrorState(state, error) {
    state.companiesOfInterestErrorState = error;
  },
  mutateCountSavedCompaniesOfInterestState(state, count) {
    state.countSavedCompaniesOfInterestState = count;
  },
  setReferrerProfileState(state, newProfile) {
    state.referrerProfileState = newProfile;
  }
};
